import React from 'react';
import './App.css';
import { useEffect } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import GenerateRoutes from './routes/Routes';
import DisplayDisclaimerAndUpdateHtml from './components/displays/displaydisclaimerandupdatehtml/DisplayDisclaimerAndUpdateHtml';
import { WebsocketStore } from './stores/websocketStore/websocketStore';
import { WebSocketProvider } from './stores/websocketStore/websocketProvider';
import { observer } from 'mobx-react-lite';

const socketStore = new WebsocketStore();
export const sendWebsocketMessage = socketStore.sendWebsocketMessage;
export { socketStore };

const disconnectBannerStyle = {
  position: 'sticky',
  top: 0,
  zIndex: 10000,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '12px',
  padding: '10px 16px',
  background: '#6a1b1b',
  color: '#fff4e6',
  borderBottom: '1px solid #d28a8a',
};

const disconnectButtonStyle = {
  border: '1px solid #f0c7c7',
  background: '#fff4e6',
  color: '#4d1414',
  borderRadius: '4px',
  cursor: 'pointer',
  fontWeight: 600,
  padding: '6px 10px',
};

const AppContent = observer(() => {
  const connected = socketStore.connected;
  const dataStale = socketStore.dataStale;
  const isAuthenticated = socketStore.userAuthStore.isAuthenticated;
  const lastCloseEvent = socketStore.lastCloseEvent;
  const location = useLocation();
  const isPublicPage = location.pathname === '/ui/login' ||
                       location.pathname === '/ui/forgot-password' ||
                       location.pathname === '/ui/reset-password';

  useEffect(() => {
    socketStore.syncRoute(location.pathname);
  }, [location.pathname]);

  // If on public auth pages, don't require WebSocket connection
  if (isPublicPage) {
    return <GenerateRoutes />;
  }

  // If not authenticated, allow routing (ProtectedRoute will redirect to login)
  if (!isAuthenticated) {
    return <GenerateRoutes />;
  }

  const closeCode = lastCloseEvent?.code;
  const closeReason = lastCloseEvent?.reason?.trim();
  const socketType = lastCloseEvent?.socketType;
  const disconnectDetails = [
    socketType ? `${socketType} socket` : null,
    closeCode != null ? `Code ${closeCode}` : null,
    closeReason ? closeReason : 'No close reason provided.',
  ]
    .filter(Boolean)
    .join(' - ');

  return (
    <div className="App">
      {!connected && (
        <div style={disconnectBannerStyle}>
          <div>
            Connection to TU backend lost. Your current page state is being preserved while the app retries automatically.
            {' '}
            {disconnectDetails}
          </div>
          <button
            onClick={() => socketStore.retryConnections()}
            style={disconnectButtonStyle}
            type="button"
          >
            Reconnect Now
          </button>
        </div>
      )}
      {connected && dataStale && (
        <div style={disconnectBannerStyle}>
          <div>
            No data received from TU backend recently even though the connection looks open - prices and charts may be stale. Reconnecting automatically.
          </div>
          <button
            onClick={() => socketStore.retryConnections()}
            style={disconnectButtonStyle}
            type="button"
          >
            Reconnect Now
          </button>
        </div>
      )}
      <DisplayDisclaimerAndUpdateHtml />
      <GenerateRoutes />
    </div>
  );
});

const App = () => {
  return (
    <WebSocketProvider store={socketStore}>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </WebSocketProvider>
  );
};

export default App;
